import RichText from "@/library/rich-texts/RichText";
import { editableField } from "@/storyblok/utils/editableField";
import { sanitizeRichText } from "@/storyblok/utils/texts/sanitize";

import React from "react";

export default function RichTextBlock(props) {
  const { content, className } = props;

  const sanitizedContent = sanitizeRichText(content);
  return (
    <RichText
      {...editableField}
      richText={sanitizedContent}
      className={className}
    />
  );
}
